/**
 * Created by rlopez on 06/13/16.
 */

// AccountSettingsView.js
import $ from 'jquery';
import {Model} from 'backbone';
import BasePropertyView from 'BasePropertyView.js';
import NotificationService from 'NotificationService.js'
import RestService from 'RestService.js';
import SynchronizeMaxModalView from 'common-views/SynchronizeMaxModalView';
import SynchronizeModalView from 'common-views/SynchronizeModalView';
import SimpleConfirmModal from 'common-views/SimpleConfirmModalView.js';
import contentTemplate  from 'dashboard/settings/synchronize-details-view.ejs';
import textConstants from 'TextConstants';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import undoService from 'UndoService'
import formLoadService from 'FormLoadService';
import xjService from "../../../service/xml/XJService";
import formulaService from "../../../service/xml/FormulaService";
import util from 'util/Util.js';
import zLib  from 'util/ZLib.js';
import SynchronizeCommitModalView from 'common-views/SynchronizeCommitModalView';
import SynchronizeResultsModalView from 'common-views/SynchronizeResultsModalView';
import userService from 'UserService';
import listService from 'ListService';

class SynchronizeDetailsView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {

            'change input[type=text],input[type=password],textarea': 'manageTextInputs',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'   : 'getFocus',
            'change input[type=checkbox]': 'manageCheckboxes',
            'change select': 'manageSelects',
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=cancelChanges]': 'cancelChanges',
            'click input[name=synchronizeProfile]': 'synchronize',
            'click input[name=testProfile]': 'test',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToSettings'
        };

        const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
        const enableADSync = isBULicense ? util.isTrue(userService.checkFeatures('ADSync')) : true;

        this.model.set("enableADSync", enableADSync, {silent: true});

        this.listenTo(this.model, 'change', this.render);

        return this;
    }


    manageSelects(ev) {
        let propName=ev.currentTarget.name;
        let propVal=ev.currentTarget.value;
        let currentModel=this.model.get('currentSynchronizationProfile');
        currentModel[propName]=propVal;
        this.model.set('currentSynchronizationProfile',currentModel,constants.MODEL_SILENT);
        this.model.set('hasChanges',true,constants.MODEL_SILENT);
        this.model.set('isEmpty',false, constants.MODEL_SILENT);
        this.render();
    }


    manageTextInputs(ev) {
      let propName=ev.currentTarget.name;
      let propVal=ev.currentTarget.value;
      let currentModel=this.model.get('currentSynchronizationProfile');
      currentModel[propName]=propVal;
      this.model.set('currentSynchronizationProfile',currentModel,constants.MODEL_SILENT);
      this.model.set('hasChanges',true, constants.MODEL_SILENT);
      this.model.set('isEmpty',false, constants.MODEL_SILENT);
      this.render();

    }



    manageCheckboxes(ev) {
      let propName=ev.currentTarget.name;
      let propVal=ev.currentTarget.checked;
      let currentModel=this.model.get('currentSynchronizationProfile');
      currentModel[propName]=propVal;
      this.model.set('currentSynchronizationProfile',currentModel,{silent:true});
      this.model.set('hasChanges',true,{silent:true});
      this.model.set('isEmpty',false);
    }

    applyChanges() {
         let currentModel = this.model.get('currentSynchronizationProfile');
         const newSynchronizationParams = this.model.get('isEmpty') ? "" : this.getSynchronizationDTO(currentModel) ;
         const oldSynchronizationParams = this.model.get('isEmpty') ? "" : this.getSynchronizationDTO(this.model.get('synchronizationProfile'));

         undoService.add({
             undo: () => {
                 this.persistChanges(newSynchronizationParams)
             },
             redo: () => {
                 this.persistChanges(oldSynchronizationParams)
             }
         }, textConstants.UNDO_UPDATE_SYNCHRONIZATION);
         this.persistChanges(newSynchronizationParams)
    }

    synchronize(){
      RestService.runUsersSynchronization(true).then((synchronizeResponse)=> {
          eventBus.trigger(constants.EV_UPDATED_SYNCHRONIZATION_PROFILE);

        // Decrypt Response

          let xmlResponse=formLoadService._decompressForm(synchronizeResponse.RESULT.RESPONSE.UsersSynchronization);

        // Transform it to JSON

          let formDoc = formulaService.preprocess(xmlResponse);
          let accountTypes = xjService.xmlDocToJs(formDoc).UsersSynchronization;

          // PF-3052 Rendering different modal depending on the type of response that it has.
          // More than 3000 users.
          if(accountTypes["_type"] ==='summary'){
              let synchronizeMaxModalView = new SynchronizeMaxModalView({model:new Model({accountTypes:accountTypes,accountsChosen:[]})});
              synchronizeMaxModalView.render().then((accountsChosen)=>{
                  this.commitSummary(accountsChosen,accountTypes);
              });
          }

          // Less than 3000 users.
          else{
              if(accountTypes.Users){
                  accountTypes.Users = this.convertAccountActionsToArrayByAccountType(accountTypes.Users,'User');
              }
              if(accountTypes.UserGroups){
                  accountTypes.UserGroups = this.convertAccountActionsToArrayByAccountType(accountTypes.UserGroups,'UserGroups')
              }
              if(accountTypes.Positions){accountTypes.Positions = this.convertAccountActionsToArrayByAccountType(accountTypes.Positions,'Position')}

              let commitAccountTypes=_.cloneDeep(accountTypes);
              let synchronizeModalView = new SynchronizeModalView({model:new Model({accountTypes:accountTypes,commitAccountTypes:commitAccountTypes})});
              synchronizeModalView.render().then((accountsChosen)=>{
                    if(accountsChosen!=='Cancel'){
                        this.commit(accountsChosen);
                    }
              });
          }
      }).catch((err=> {
         console.log('Error while synchronizing ', err);
        if(err.CODE === "71"){
             NotificationService.error('An error has ocurred.\n'+
                 'The connection to the directory service could not ' +
                 'be made or the username and password were not accepted',"",{ placement: {
               from: 'bottom',
               align: 'center'
             }});
         }
         else if(err.CODE === '70'){
            NotificationService.error('An error has ocurred.\n'+
                'Some of the parameters of the Users Synchronization profile are invalid.',"",{ placement: {
                    from: 'bottom',
                    align: 'center'
                }});
        }
         else {
           NotificationService.error('Error while synchronize ' + err,"",{ placement: {
             from: 'bottom',
             align: 'center'
           }});
         }
       }));
    }

    commitSummary(accountsChosen,accountTypes){
        let counts = this.getSynchronizeSummaryCounts(accountsChosen,accountTypes);
        let synchronizeCommitModalView = new SynchronizeCommitModalView({model:new Model({counts:counts})});
        synchronizeCommitModalView.render().then((optionChosen)=>{
            if(optionChosen === 'Ok') {
                // Starting to shape response....
                let requestMessage = `<UsersSynchronization session='${accountTypes['_session']}' type="${accountTypes['_type']}">`;
                requestMessage+=`<Users new='${counts.userNewCount}' change="${counts.userChangeCount}" remove="${counts.userRemoveCount}"/>`;
                requestMessage+=`<UserGroups new='${counts.userGroupNewCount}' change="${counts.userGroupChangeCount}" remove="${counts.userGroupRemoveCount}"/>`;
                requestMessage+=`<Positions new='${counts.positionNewCount}' change="${counts.positionChangeCount}" remove="${counts.positionRemoveCount}"/>`;
                requestMessage+=`</UsersSynchronization>`;

                // Compressing
                let compressedRequest = zLib.compressForm(requestMessage);

                // Calling Synchronization
                RestService.commitUsersSynchronization(compressedRequest,true).then((result) => {

                    // Calling Results of Synchronization Process
                    let results = result.RESULT.RESPONSE;

                    let processedResultsText = this.processResults(results);

                    let synchronizeResultsModalView = new SynchronizeResultsModalView({model: new Model({resultsText: processedResultsText})});
                    synchronizeResultsModalView.render().then((optionChosen) => {

                    }).catch((error) => {
                        console.log(error);

                        const msg = error || 'Unknown Error on Results Commit Modal';
                        NotificationService.error(msg);
                    })
            })
            }
        })
    }

    commit(accountsChosen){
        let counts = this.getSynchronizeCounts(accountsChosen);


        // Rendering screen of the results to be committed.
        let synchronizeCommitModalView = new SynchronizeCommitModalView({model:new Model({counts:counts})});
        synchronizeCommitModalView.render().then((optionChosen)=>{
            if(optionChosen === 'Ok') {
                // Starting to shaping response....
                let requestMessage = `<UsersSynchronization session='${accountsChosen['_session']}' type="${accountsChosen['_type']}">`;
                requestMessage = this.processUsers(accountsChosen,requestMessage);
                requestMessage = this.processUserGroups(accountsChosen,requestMessage);
                requestMessage = this.processPositions(accountsChosen,requestMessage);
                requestMessage += `</UsersSynchronization>`;

                // Compressing
                let compressedRequest = zLib.compressForm(requestMessage);

                // Calling Synchronization
                RestService.commitUsersSynchronization(compressedRequest,true).then((result) => {

                    // Calling Results of Synchronization Process
                    let results = result.RESULT.RESPONSE;

                    let processedResultsText = this.processResults(results);

                    let synchronizeResultsModalView = new SynchronizeResultsModalView({model: new Model({resultsText: processedResultsText})});
                    synchronizeResultsModalView.render().then((optionChosen) => {

                    }).catch((error) => {
                        console.log(error);
                        const msg = error || 'Unknown Error on Results Commit Modal';
                        NotificationService.error(msg);
                    })
                }).catch((error) => {
                    console.log(error);
                    const msg = error || 'Unknown Error on Commit Screen Modal';
                    NotificationService.error(msg);
                });
            }
        }).catch((error) => {
            console.log(error);
            const msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    processResults(resultsText){
        let processedText="";
        if(resultsText.UsersNew !== '0'){processedText += `${resultsText.UsersNew} Users - New<br />`}
        if(resultsText.UsersChange !== '0'){processedText += `${resultsText.UsersChange} Users - Changed<br />`}
        if(resultsText.UsersRemove !== '0'){processedText += `${resultsText.UsersRemove} Users - Removed<br />`}
        if(resultsText.UserGroupsNew !== '0'){processedText += `${resultsText.UserGroupsNew} User Groups - New<br />`}
        if(resultsText.UserGroupsChange !== '0'){processedText += `${resultsText.UserGroupsChange} User Groups - Changed<br />`}
        if(resultsText.UserGroupsRemove !== '0'){processedText += `${resultsText.UserGroupsRemove} User Groups - Removed<br />`}
        if(resultsText.PositionsNew !== '0'){processedText += `${resultsText.PositionsNew} Positions - New<br />`}
        if(resultsText.PositionsChange !== '0'){processedText += `${resultsText.PositionsChange} Positions - Changed<br />`}
        if(resultsText.PositionsRemove !== '0'){processedText += `${resultsText.PositionsRemove} Positions - Removed<br />`}
        return processedText;
    }

    processUsers(accountsChosen,requestMessage) {
        let processedRequestWithUsers=requestMessage;
        // Getting whole users to commit
        if (accountsChosen.Users && accountsChosen.Users.New && accountsChosen.Users.New.length > 0 ||
            accountsChosen.Users && accountsChosen.Users.Change && accountsChosen.Users.Change.length > 0 ||
            accountsChosen.Users && accountsChosen.Users.Remove && accountsChosen.Users.Remove.length > 0) {
            processedRequestWithUsers += `<Users>`;
            Object.entries(accountsChosen.Users).forEach(([type, usersOfType]) => {
                if (type === 'New' && usersOfType.length > 0) {
                    processedRequestWithUsers += `<New>`;
                    usersOfType.forEach((user) => {
                        processedRequestWithUsers += `<User guid="${user['_guid']}" firstname="${util.escapeXMLEntities(user['_firstName'])}" lastname="${util.escapeXMLEntities(user['_lastName'])}" email="${user['_email']}"/>`;
                    });
                    processedRequestWithUsers += `</New>`;
                }
                else if (usersOfType.length > 0) {
                    processedRequestWithUsers += `<${type}>`;
                    usersOfType.forEach((user) => {
                        processedRequestWithUsers += `<User id="${user['_id']}" name="${util.escapeXMLEntities(user['_name'])}" Status="${user['_Status']}"/>`;
                    });
                    processedRequestWithUsers += `</${type}>`;
                }
            });
            processedRequestWithUsers += `</Users>`;
        }
        return processedRequestWithUsers;
    }

    processUserGroups(accountsChosen,requestMessage){
        let processedRequestWithUserGroups=requestMessage;
        if(accountsChosen.UserGroups && accountsChosen.UserGroups.New && accountsChosen.UserGroups.New.length > 0 ||
            accountsChosen.UserGroups && accountsChosen.UserGroups.Change && accountsChosen.UserGroups.Change.length > 0 ||
            accountsChosen.UserGroups && accountsChosen.UserGroups.Remove && accountsChosen.UserGroups.Remove.length > 0 ){
            processedRequestWithUserGroups += `<UserGroups>`;
            Object.entries(accountsChosen.UserGroups).forEach(([type,usersOfType])=>{
                if (type === 'New' && usersOfType.length > 0) {
                    processedRequestWithUserGroups += `<New>`;
                    usersOfType.forEach((userGroup) => {
                        processedRequestWithUserGroups += `<UserGroups name="${util.escapeXMLEntities(userGroup['_name'])}" guid="${userGroup['_guid']}"`;
                        if(userGroup.Member){
                            let members=util.enforceArrayType(userGroup.Member);
                            processedRequestWithUserGroups += `>`;
                            members.forEach((member)=>{
                                processedRequestWithUserGroups += `<Member guid="${member['_guid']}" name="${util.escapeXMLEntities(member['_name'])}" />`;
                            });
                            processedRequestWithUserGroups += `</UserGroups>`;
                        }
                        else{
                            processedRequestWithUserGroups +=`/>`;
                        }
                    });
                    processedRequestWithUserGroups += `</New>`;
                }
                else if(usersOfType.length > 0){
                    processedRequestWithUserGroups += `<${type}>`;
                    usersOfType.forEach((user)=>{
                        processedRequestWithUserGroups +=`<UserGroups id="${user['_id']}" name="${util.escapeXMLEntities(user['_name'])}"/>`;
                    });
                    processedRequestWithUserGroups += `</${type}>`;
                }
            });
            processedRequestWithUserGroups+=`</UserGroups>`;
        }
        return processedRequestWithUserGroups;
    }

    processPositions(accountsChosen,requestMessage){
        let processedRequestWithPositions=requestMessage;
        if(accountsChosen.Positions && accountsChosen.Positions.New && accountsChosen.Positions.New.length > 0 ||
            accountsChosen.Positions && accountsChosen.Positions.Change && accountsChosen.Positions.Change.length > 0 ||
            accountsChosen.Positions && accountsChosen.Positions.Remove && accountsChosen.Positions.Remove.length > 0 ){
            processedRequestWithPositions += `<Positions>`;
            Object.entries(accountsChosen.Positions).forEach(([type,usersOfType])=>{
                if (type === 'New' && usersOfType.length > 0) {
                    processedRequestWithPositions += `<New>`;
                    usersOfType.forEach((position) => {
                        processedRequestWithPositions += `<Position name="${util.escapeXMLEntities(position['_name'])}" guid="${position['_guid']}"`;
                        if(position.Member){
                            let members=util.enforceArrayType(position.Member);
                            processedRequestWithPositions += `>`;
                            members.forEach((member)=>{
                                processedRequestWithPositions += `<Member guid="${member['_guid']}" name="${util.escapeXMLEntities(member['_name'])}" />`;
                            });
                            processedRequestWithPositions += `</Position>`;
                        }
                        else{
                            processedRequestWithPositions +=`/>`;
                        }
                    });
                    processedRequestWithPositions += `</New>`;
                }
                else if(usersOfType.length > 0){
                    processedRequestWithPositions += `<${type}>`;
                    usersOfType.forEach((user)=>{
                        processedRequestWithPositions +=`<Position id="${user['_id']}" name="${util.escapeXMLEntities(user['_name'])}"/>`;
                    });
                    processedRequestWithPositions += `</${type}>`;
                }
            });
            processedRequestWithPositions+=`</Positions>`;
        }
        return processedRequestWithPositions;
    }

    getSynchronizeSummaryCounts(accountsChosen,accountTypes){
        let userNewCount = 0,userChangeCount = 0,userRemoveCount = 0;
        let userGroupNewCount = 0,userGroupChangeCount = 0,userGroupRemoveCount = 0;
        let positionNewCount = 0,positionChangeCount = 0,positionRemoveCount = 0;

        // Filling the counts for next screen.
        accountsChosen.forEach(account => {
            switch (account){
                case constants.SYNCHRONIZATION_USERS_NEW:userNewCount=accountTypes.Users['_new'];break;
                case constants.SYNCHRONIZATION_USERS_CHANGE:userChangeCount=accountTypes.Users['_change'];break;
                case constants.SYNCHRONIZATION_USERS_REMOVE:userRemoveCount=accountTypes.Users['_remove'];break;

                case constants.SYNCHRONIZATION_USER_GROUPS_NEW:userGroupNewCount=accountTypes.UserGroups['_new'];break;
                case constants.SYNCHRONIZATION_USER_GROUPS_CHANGE:userGroupChangeCount=accountTypes.UserGroups['_change'];break;
                case constants.SYNCHRONIZATION_USER_GROUPS_REMOVE:userGroupRemoveCount=accountTypes.UserGroups['_remove'];break;


                case constants.SYNCHRONIZATION_POSITIONS_NEW:positionNewCount=accountTypes.Positions['_new'];break;
                case constants.SYNCHRONIZATION_POSITIONS_CHANGE:positionChangeCount=accountTypes.Positions['_change'];break;
                case constants.SYNCHRONIZATION_POSITIONS_REMOVE:positionRemoveCount=accountTypes.Positions['_remove'];break;
            }
        });

        return {
            userNewCount,userChangeCount ,userRemoveCount,
            userGroupNewCount,userGroupChangeCount,userGroupRemoveCount ,
            positionNewCount ,positionChangeCount ,positionRemoveCount
        }
    }

    getSynchronizeCounts(accountsChosen){
        let userNewCount = 0,userChangeCount = 0,userRemoveCount = 0;
        let userGroupNewCount = 0,userGroupChangeCount = 0,userGroupRemoveCount = 0;
        let positionNewCount = 0,positionChangeCount = 0,positionRemoveCount = 0;

        // Filling the counts for next screen.
        if(accountsChosen.Users){
            if (accountsChosen.Users.New){
                userNewCount=accountsChosen.Users.New.length
            }
            if (accountsChosen.Users.Change){
                userChangeCount=accountsChosen.Users.Change.length
            }
            if (accountsChosen.Users.Remove){
                userRemoveCount=accountsChosen.Users.Remove.length
            }
        }
        if(accountsChosen.UserGroups){
            if (accountsChosen.UserGroups.New){
                userGroupNewCount=accountsChosen.UserGroups.New.length
            }
            if (accountsChosen.UserGroups.Change){
                userGroupChangeCount=accountsChosen.UserGroups.Change.length
            }
            if (accountsChosen.UserGroups.Remove){
                userGroupRemoveCount=accountsChosen.UserGroups.Remove.length
            }
        }

        if(accountsChosen.Positions){
            if (accountsChosen.Positions.New){
                positionNewCount=accountsChosen.Positions.New.length
            }
            if (accountsChosen.Positions.Change){
                positionChangeCount=accountsChosen.Positions.Change.length
            }
            if (accountsChosen.Positions.Remove){
                positionRemoveCount=accountsChosen.Positions.Remove.length
            }
        }
        return {
            userNewCount,userChangeCount ,userRemoveCount,
            userGroupNewCount,userGroupChangeCount,userGroupRemoveCount ,
            positionNewCount ,positionChangeCount ,positionRemoveCount
        }
    }

    convertAccountActionsToArrayByAccountType(accountType,name){
        if(accountType.New){ accountType.New = util.enforceArrayType(accountType.New[name]) }
        if(accountType.Remove){ accountType.Remove = util.enforceArrayType(accountType.Remove[name]) }
        if(accountType.Change){ accountType.Change = util.enforceArrayType(accountType.Change[name]) }
        return accountType;
    }

    test(){
      RestService.testSynchronizationProfile().then((testSynchronizeResponse)=> {
        NotificationService.success("The test was successful","",{ placement: {
          from: 'bottom',
          align: 'center'
        }});
        eventBus.trigger(constants.EV_UPDATED_SYNCHRONIZATION_PROFILE);
      }).catch((err=> {
        if(err.CODE === "70"){
          NotificationService.error('The test failed.\n'+
              'Some of the parameters of the Users Synchronization profile are invalid ',
              "",{ placement: {
            from: 'bottom',
            align: 'center'
          }});
        }
        else {
          NotificationService.error('Error while synchronize ' + err,"",{ placement: {
            from: 'bottom',
            align: 'center'
          }});
        }
      }));
    }

    getSynchronizationDTO(model){
        let synchronizationMessage=
            `<UsersSynchronizationProfile>`+
            `<Connection type="${model.type}" host="${model.host}" port="${model.port}" useSSL="${model.useSSL}" useGlobal="${model.useGlobal}" username="${model.username}" password="${model.password}"/>`+
            `<Options includeUserGroups="${model.includeUserGroups}" includePositions="${model.includePositions}" defaultUserStatus="${model.defaultUserStatus}" allowSelfSignedCert="${model.allowSelfSignedCert}"/>`+
            `<AutoSynch add="${model.add}" change="${model.change}" remove="${model.remove}" />`+
            `<LookUp context="${model.context}" objectClass="${model.objectClass}" filter="${model.filter}" subcontexts="${model.subcontexts}" />`+
            `<Mappings guid="${model.guid}" firstName="${model.firstName}" lastName="${model.lastName}" email="${model.email}" userGroups="${model.userGroups}" position="${model.position}" ` +
            `domainUsername="${model.domainUsername}" domainUsernamePrefix="${model.domainUsernamePrefix}" domainUsernameSuffix="${model.domainUsernameSuffix}" phone="${model.phone}" cellphone="${model.cellphone}" `+
            `fax="${model.fax}" skype="${model.skype}" alternateEmail="${model.alternateEmail}" customId="${model.customId}" address1="${model.address1}" address2="${model.address2}" city="${model.city}" state="${model.state}" `+
            `zipCode="${model.zipCode}" country="${model.country}" />`+
            `</UsersSynchronizationProfile>`;
        return synchronizationMessage.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    persistChanges(profileXML){
        RestService.updateSynchronizationProfile(profileXML).then((updateResponse)=> {
            eventBus.trigger(constants.EV_UPDATED_SYNCHRONIZATION_PROFILE);
        }).catch((err=> {
            NotificationService.error('Error while updating synchronization profile' + err);
        }));
    }
    


    cancelChanges() {
        this.model.set('currentSynchronizationProfile',Object.assign({},this.model.get('synchronizationProfile')),{silent:true});
        this.model.set('hasChanges',false);
        this.render();
    }

    render() {
        const html = this.template(this.model.toJSON());
        $(this.$el[0]).html(html);

        $('#detailHeading').html('Settings - Dashboard');
        $(`option[value="${this.model.get("currentSynchronizationProfile").defaultUserStatus}"]`).prop('selected',true);

        if(!this.model.get("enableADSync")){
            this.dialog = util.newDashboardModal("#featureDisabled", 
            {
                title: "Active Directory Sync Not Enabled", 
                hideTitleBar: false, 
                closeEsc: true, 
                width: 515,
                titleBarClass: "dashboard-modal-dialog-titlebar-notification",
                titleClass: "dashboard-modal-title-notification",
                buttons:  [{
                    text: 'Ok',
                    'class':'btn-select-field',
                    click: () => {
                        this.dialog.dialog("close");
                    }
                }]
            }).dialog("open");
            this.dialog.dialog( "option", "position", { my: "center center-150", at: "center", of: window } );            
        }

        this.$el.css('cursor', 'default');
        this.delegateEvents();
        return this;
    }

    refresh(){
        if(this.model.get('hasChanges')){            
            let simpleModal=new SimpleConfirmModal({
                model:new Model({subtitle:`Syncronize Users With Directory Service`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_SYNCHRONIZE_DETAILS);
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_SYNCHRONIZE_DETAILS);
        }  
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();
    }
}

export default SynchronizeDetailsView;

